module.exports = __webpack_public_path__ + "img/home.e38fc4ec.svg";